import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-alert-component',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlertComponent {
  @Input() text: string;
  @Input() status: 'warning' | 'info';
  @Input() alignment: 'left' | 'center' | 'right' = 'center';
}
